 /*jshint esversion: 6 */
 /* The Vue build version to load with the `import` command
 (runtime-only or standalone) has been set in webpack.base.conf with an alias. */

const path = require('path');

import Vue from 'vue';
import App from './App';
import router from './router';
import Vuetify from 'vuetify';
import VueShortkey from 'vue-shortkey';
import VueTouch from 'vue-touch';
import VueResource from 'vue-resource';
import VueAnalytics from 'vue-analytics'

Vue.use(Vuetify);
Vue.use(VueShortkey);
Vue.use(VueResource);

VueTouch.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

Vue.use(VueTouch, {name: 'v-touch'});


Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
  id: ['UA-137347938-1','UA-64435914-1'],
  router,
  autoTracking: {
    pageviewTemplate (route) {
      return {
        page: path.join(window.location.pathname,route.path),
        title: document.title,
        location: window.location.href
      }
    }
  },
  debug: {
    enabled: false
}
})

const app = new Vue({
  el: '#app',
  data: {},
  router,
  render: h => h(App)
}).$mount('#app');




// WEBPACK FOOTER //
// ./src/main.js